<div class="container-fluid schedule-container">
    <div *ngIf="isSchedulesLoaded" class="row mx-0 px-0">
        <div class="col-3 mx-0 px-0 d-flex flex-column">
            <div class="row mx-0 px-0 accello-general-text6">
                Schedules
            </div>
            <div class="row mx-0 pt-0 search-container">
                <input type="text" class="search-input form-control" [(ngModel)]="searchText" (keyup)="modifyCaseTree()" placeholder="Search Test Schedules">
            </div>
            <div class="mx-0 switches-container flex-grow-1">
                <div class="checkbox-switch-container" [ngClass]="{ 'highlight': activeSchedule?.name === schedule.name }"  *ngFor="let schedule of schedules" (click)="buildDataSourceFromObject(schedule)" (keydown)="buildDataSourceFromObject(schedule)" (dblclick)="editSchedule(schedule)" >
                    <input type="checkbox" class="checkbox" [checked]="schedule.checked" (click)="updateSchecules($event,schedule,'checked')" (keydown.enter)="updateSchecules($event,schedule,'checked')" />
                    <span class="text" [title]="schedule.name">
                      {{schedule.name}}
                    </span>
                    <label class="switch">
                      <input type="checkbox" [checked]="schedule.enabled" (click)="updateSchecules($event,schedule,'enabled')" (keydown.enter)="updateSchecules($event,schedule,'enabled')"/>
                      <span class="slider"></span>
                    </label>
                </div>
            </div>
        </div>
        <div class="col-9 mx-0 px-0 lable-text">
            <div  *ngIf="isSchedulesByIdloaded" class="right-side-container">
                <div class="d-flex mx-0 px-0 mb-2 justify-content-end">
                    <div class="mx-2">
                        <button class="btn-accello-secondary btn-accello" (click)="addOrRemoveTestSchedule('+')">
                          <img src="assets/images/virtusa-icons/add.png" alt="add">
                          Add New Test Schedule
                        </button>
                    </div>
                    <div>
                        <button class="btn-accello-ternary btn-accello" (click)="addOrRemoveTestSchedule('-')">
                          <img src="assets/images/virtusa-icons/remove.png" alt="remove">
                          Remove Test Schedule
                        </button>
                    </div>
                </div>
                <div class="row mx-0 px-0" *ngIf="activeSchedule">
                  <div class="d-flex mx-0 sliders-container align-items-center">
                    <span class="header-2 ellipsis"> {{activeSchedule.name}} </span>
                    <!-- <img class="edit-icon mx-2" src="assets/images/virtusa-icons/edit.png" alt="edit"> -->
                    <div class="d-flex flex-grow-1 mx-2 justify-content-end">
                      <div class="d-flex cron-inp rounded-1 overflow-hidden">
                        <div class="d-flex align-items-center h-100 px-2"> Cron Expression </div>
                        <input
                          type="text" 
                          id="cronExpression" 
                          class="form-control m-0 cron-input h-100" 
                          placeholder="Enter cron expression" 
                          [(ngModel)]="cronExpression" 
                          (input)="validateCronExpression()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mx-0 px-0">
                  <app-zorro-table
                    tableId="tc-schdl"
                    class="w-100 px-0"
                    [columns]="columns"
                    [data]="dataSource"
                    [options]="tableOptions"
                  ></app-zorro-table>
                </div>
                <div class="border rounded p-2 d-flex align-items-center justify-content-between footer-wrap">
                  <div class="d-flex mx-0 justify-content-end">
                    <div class="toggle-wrap v-center px-2 rounded">
                      <div class="d-flex">
                        <div class="v-center accello-general-text-6" [ngClass]="{ 'highlight': isAnalysUp }"> Test Failure Analysis </div>
                        <div class="form-check form-switch mx-2 v-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [(ngModel)]="isAnalysUp"
                              role="switch"
                              id="flexSwitchCheckChecked"
                            />
                        </div>
                      </div>
                    </div>
      
                    <div class="toggle-wrap v-center px-2 rounded mx-2">
                      <div class="d-flex">
                        <div class="v-center accello-general-text-6" [ngClass]="{ 'highlight': isSelfHealingUp }"> Self-Healing </div>
                        <div class="form-check form-switch mx-2 v-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [(ngModel)]="isSelfHealingUp"
                              role="switch"
                              id="flexSwitchCheckChecked"
                            />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <!-- <div for="cronExpression" class="bg-primary text-white py-1 px-2 rounded-start m-0 cron-lable">Cron Expression</div>
                    <input 
                      type="text" 
                      id="cronExpression" 
                      class="form-control m-0 cron-input" 
                      placeholder="Enter cron expression" 
                      [(ngModel)]="cronExpression" 
                      (input)="validateCronExpression()"
                    />
                    <button class="btn btn-outline-secondary m-0 cron-calender" (click)="openCalendar()">
                    <mat-icon>calendar_month</mat-icon>
                    </button> -->
                    <button class="btn-accello-primary btn-accello"  [disabled]="cronExpression.trim() =='' || !activeSchedule?.id" [matMenuTriggerFor]="menu">
                      <img src="assets/images/virtusa-icons/save.svg" alt="save">
                      Save Test Schedule
                    </button>
                    <mat-menu #menu="matMenu">
                      <button class="context-menu" mat-menu-item (click)="save('+')">With Release</button>
                      <button class="context-menu" mat-menu-item (click)="save()">Without Release</button>
                    </mat-menu>
                  </div>
                </div>
                
            </div>
            <div *ngIf="!isSchedulesByIdloaded" class="load-wrap v-center">
              <app-loading [text]="'Loading data'"></app-loading>
          </div>
            
        </div>
    </div>
    <div *ngIf="!isSchedulesLoaded" class="load-wrap v-center">
      <app-loading [text]="'Loading data'"></app-loading>
  </div>
</div>
